var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.logicType ? 'edn-switch' : 'edn-check',_vm._g({tag:"component",attrs:{"label":_vm.label,"readonly":_vm.readonly,"required":_vm.required,"tooltip":_vm.tooltip,"disabled":_vm.disabled,"labelStyles":_vm.$attrs.labelStyles},model:{value:(_vm.Value),callback:function ($$v) {_vm.Value=$$v},expression:"Value"}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }